import { object, text } from '../../lib/workflows/repository';
import type { Value } from '../../lib/workflows/types';
import { Badge } from '../ui/badge';
import { fifoPresentation } from '../../lib/warehouse/presentation';

export function FifoEvidence({ value, compact = false }: { value: Value; compact?: boolean }) {
  const check = object(value);
  const presentation = fifoPresentation(value);
  const warning = presentation.state === 'older_lot_available';
  if (compact)
    return (
      <Badge
        variant={presentation.tone}
        title={presentation.explanation}
        className="whitespace-normal"
      >
        {presentation.label}
      </Badge>
    );
  return (
    <div
      className={`rounded-field border p-4 ${warning ? 'border-warning bg-warning-bg' : 'border-border'}`}
    >
      <Badge variant={presentation.tone}>{presentation.label}</Badge>
      <p className="mt-2 text-body">{presentation.explanation}</p>
      {Array.isArray(check.older_lots) && check.older_lots.length > 0 && (
        <ul className="mt-3 space-y-1">
          {check.older_lots.map((value, i) => {
            const lot = object(value);
            return (
              <li key={i} className="text-micro">
                {text(lot.lot_code)} · Manufactured {text(lot.manufacture_date)} · Available{' '}
                {text(lot.available_quantity)}
              </li>
            );
          })}
        </ul>
      )}
      {Array.isArray(check.undated_lots) && check.undated_lots.length > 0 && (
        <p className="mt-2 text-micro">
          Undated lots excluded from comparison: {check.undated_lots.map(text).join(', ')}
        </p>
      )}
    </div>
  );
}
